<template>
  <transition name="ar-fade">
    <div v-if="open" class="ar-backdrop" @mousedown.self="$emit('close')">
      <div
        ref="dialog"
        class="ar-modal"
        :class="'ar-modal-' + size"
        role="dialog"
        aria-modal="true"
        :aria-labelledby="titleId"
        tabindex="-1"
        @keydown.esc.stop="$emit('close')"
      >
        <div class="ar-modal-head">
          <div class="ar-modal-heading">
            <h5 :id="titleId" class="ar-modal-title">{{ title }}</h5>
            <p v-if="subtitle" class="ar-modal-sub">{{ subtitle }}</p>
          </div>
          <slot name="head" />
          <button type="button" class="ar-modal-x" aria-label="Close" @click="$emit('close')">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
        <div class="ar-modal-body" :class="{ flush }">
          <slot />
        </div>
        <div v-if="$slots.footer" class="ar-modal-foot">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
let uid = 0;

/** A dialog for the Archives pages. Escape or a click outside closes it. */
export default {
  name: "ArchiveModal",
  props: {
    open: { type: Boolean, default: false },
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    size: { type: String, default: "md" }, // sm, md, lg, xl, guide
    flush: { type: Boolean, default: false },
  },
  data() {
    return { titleId: `ar-modal-title-${++uid}` };
  },
  watch: {
    open: {
      immediate: true,
      handler(value) {
        if (value) {
          this.opener = document.activeElement;
          document.body.style.overflow = "hidden";
          this.$nextTick(() => {
            const dialog = this.$refs.dialog;
            if (!dialog) return;
            const first = dialog.querySelector("[autofocus], input:not([type=hidden]), textarea, select");
            (first || dialog).focus();
          });
        } else {
          document.body.style.overflow = "";
          if (this.opener && document.body.contains(this.opener)) this.opener.focus();
          this.opener = null;
        }
      },
    },
  },
  beforeDestroy() {
    document.body.style.overflow = "";
  },
};
</script>
